/**
=========================================================
* Material Dashboard 2 PRO React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

import { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

// @mui material components
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import Autocomplete from "@mui/material/Autocomplete";

// Material Dashboard 2 PRO React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDEditor from "components/MDEditor";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";

import { Radio, RadioGroup, FormControlLabel, FormControl, FormLabel, Switch } from "@mui/material";

import Chip from "@mui/material/Chip";
import Stack from "@mui/material/Stack";

// NewProduct page components
import FormField from "layouts/ecommerce/products/edit-product/components/FormField";
import { SeatsioSeatingChart } from "@seatsio/seatsio-react";
import { Typography } from "@mui/material";
import { formatedTime } from "utils/formattedDate";
import { formatedDate } from "utils/formattedDate";
import { getAllCouponsApi } from "api/coupons";
import { AuthContext } from "context/authContext";

function FormFields({
  formValues,
  currentFormValues,
  eventData,
  selectedPlaceEvent,
  actionButton,
}) {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.only("sm"));

  const { userRole } = useContext(AuthContext);

  const [formDataValues, setFormDataValues] = useState({
    fromEvent: "",
    ticketType: "",

    firstName: "",
    lastName: "",
    email: "",
    phone: "",

    couponCode: "",
    availableCouponCode: [],
    selectedCategory: "",
    availableCategories: [],

    selectedCategoryPrice: 0,
    numberOfTickets: 0,
    pricing: [],

    sumOfPrice: 0,

    isSelectetivePlaces: false,
    seatIoId: "",
    buyFromType: "offline",

    selectedTimeId: "",
    isCinema: false,
    isCirque: false,
  });

  const [selectedPlaces, setSelectedPlaces] = useState([]);
  const [selectedEventDatesList, setSelectedEventDatesList] = useState([]);

  // seatio methods
  const customColors = {
    availableObjectColor: "#6C096C",
    selectedObjectColor: "#00FF00",
  };
  const handleChartRendered = (chartManager) => {
    // setChartRendered(true);
    // console.log("chartManager", chartManager)
    // chartManager.initialContainerDimensions.width = 1200
    // chartManager.domElementListener.lastDimensions.width = 1200
  };

  const objectPopoverParams = {
    showAvailability: true,
    showCategory: true,
    showLabel: true,
    showPricing: true,
    showUnavailableNotice: true,
    stylizedLabel: true,
    confirmSelection: "never", // always - never
  };
  const handleSelectedObject = (object) => {
    console.log("object", object.pricing.price);
    // Add the object to the selectedPlaces array if it's not already present
    setSelectedPlaces((prevSelectedPlaces) => {
      if (!prevSelectedPlaces.some((place) => place.label === object.label)) {
        selectedPlaceEvent([...prevSelectedPlaces, object]);
        return [...prevSelectedPlaces, object];
      }
      selectedPlaceEvent(prevSelectedPlaces);
      return prevSelectedPlaces;
    });

    const newFormDataValues = {
      ...formDataValues,
      sumOfPrice: parseFloat(formDataValues.sumOfPrice) + parseFloat(object.pricing.price),
      numberOfTickets: parseInt(formDataValues.numberOfTickets) + 1,
    };
    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };
  const handleDeselectedObject = (object) => {
    // Remove the object from the selectedPlaces array
    setSelectedPlaces((prevSelectedPlaces) => {
      const selectedData = prevSelectedPlaces.filter((place) => place.label !== object.label);
      selectedPlaceEvent(selectedData);
      return selectedData;
    });

    const newFormDataValues = {
      ...formDataValues,
      sumOfPrice: parseFloat(formDataValues.sumOfPrice) - parseFloat(object.pricing.price),
      numberOfTickets: parseInt(formDataValues.numberOfTickets) - 1,
    };
    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };
  const handleSelectedObjects = (objects) => {
    console.log("handleSelectedObjects", objects.label);
  };

  const handleRadioChange = (event) => {
    const newFormDataValues = {
      ...formDataValues,
      ticketType: event.target.value,
    };

    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };

  const handleSelectedHourRadioChange = (event) => {
    const newTimeId = event.target.value;
    let updatedCategories = formDataValues.availableCategories;

    if (formDataValues.isCinema || formDataValues.isCirque) {
      const selectedDate = selectedEventDatesList.find((d) => d.generatedId === newTimeId);
      if (selectedDate?.prices?.length) {
        updatedCategories = selectedDate.prices;
      } else {
        updatedCategories = [];
      }
    }

    const newFormDataValues = {
      ...formDataValues,
      selectedCategory: "",
      sumOfPrice: 0,
      selectedCategoryPrice: 0,
      selectedTimeId: newTimeId,
      availableCategories: updatedCategories,
    };

    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    if (name === "numberOfTickets") {
      if (value < 0) return;
      else if (value > 50) return;

      const newFormDataValues = {
        ...formDataValues,
        [name]: value,
        sumOfPrice: parseFloat(formDataValues.selectedCategoryPrice) * parseInt(value),
      };
      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    } else {
      const newFormDataValues = {
        ...formDataValues,
        [name]: value,
      };
      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    }
  };
  const handleAutoCompleteEventChange = async (event, newValue) => {
    try {
      // get one event coupon code
      // console.log("handleAutoCompleteEventChange")

      const eventCoupon = await getAllCouponsApi(null, null, null, newValue?.id)

      setSelectedEventDatesList(newValue?.eventDateList || []);

      const selectedPricing = [];
      newValue.eventSiege.map((el) => {
        selectedPricing.push({
          category: el.name,
          originalPrice: el.price,
          price: el.price,
        });
      });

      newValue.eventSiege.map(el => {
        el.originalPrice = el.price
      })

      const isCinemaOrCirque = !!(newValue?.isCinema || newValue?.isCirque);

      const newFormDataValues = {
        ...formDataValues,
        fromEvent: newValue ? newValue?.id : "",
        availableCategories: isCinemaOrCirque ? [] : newValue.eventSiege,
        selectedCategory: "",

        availableCouponCode: eventCoupon,
        selectedCouponCode: "",

        selectedCategoryPrice: 0,
        isSelectetivePlaces: newValue.isSelectetivePlaces,
        seatIoId: newValue.seatIoId,
        pricing: selectedPricing,
        coponCode: eventCoupon,

        numberOfTickets: 0,
        sumOfPrice: 0,

        selectedTimeId: "",
        isCinema: newValue?.isCinema || false,
        isCirque: newValue?.isCirque || false,
      };

      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    } catch (err) {
      console.log(err);
    }
  };
  const handleAutoCompleteCouponChange = async (event, newValue) => {
      // const newFormDataValues = {
      //   ...formDataValues,
      //   selectedCouponCode: newValue ? newValue?._id : "",
      // };

      // event siege ids
      const siegeId = newValue?.siege.map(el => el.id)

      // Create a new array with updated prices
      const updatedCategories = formDataValues?.availableCategories.map(el => {
        if (siegeId && siegeId.includes(el.id)) {
          let newPrice = el.originalPrice;
          if (newValue.typeOfCopon === "pourcentage") {
            newPrice = newPrice - el.originalPrice * parseFloat(newValue.reduction / 100);
          } else if (newValue.typeOfCopon === "montant") {
            newPrice = newPrice - newValue.reduction;
          }
          return { ...el, price: newPrice }; // return a new object
        }
        return el;
      });
      const updatedCategories2 = formDataValues?.availableCategories.map(el => {
          let newPrice = el.originalPrice;
          return { ...el, price: newPrice }; // return a new object
      });

      // Update state immutably
      const newFormDataValues = {
        ...formDataValues,
        
        selectedCategory: "",
        sumOfPrice: 0,
        selectedCategoryPrice: 0,

        couponCode: newValue?._id || "",
        availableCategories: siegeId && siegeId.length !== 0 ? updatedCategories : updatedCategories2,
      };

      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
  }
  const handleAutoCompleteSeigeChange = async (event, newValue) => {
    try {
      const newFormDataValues = {
        ...formDataValues,
        selectedCategory: newValue ? newValue?.id : "",
        sumOfPrice: parseFloat(newValue.price) * parseInt(formDataValues.numberOfTickets),
        selectedCategoryPrice: parseFloat(newValue.price),
      };

      setFormDataValues(newFormDataValues);
      formValues(newFormDataValues);
    } catch (err) {
      console.log(err);
    }
  };
  const handleBuyFromChange = (event) => {
    const newFormDataValues = {
      ...formDataValues,
      buyFromType: event.target.checked ? "online" : "offline",
    };

    setFormDataValues(newFormDataValues);
    formValues(newFormDataValues);
  };

  useEffect(() => {
    console.log("FormFields: currentFormValues prop changed", currentFormValues);

    if (currentFormValues && currentFormValues.formInfo) {
      setFormDataValues({
        fromEvent: currentFormValues.formInfo.fromEvent || "",
        ticketType: currentFormValues.formInfo.ticketType || "",
        firstName: currentFormValues.formInfo.firstName || "",
        lastName: currentFormValues.formInfo.lastName || "",
        email: currentFormValues.formInfo.email || "",
        phone: currentFormValues.formInfo.phone || "",
        couponCode: currentFormValues.formInfo.couponCode || "",

        availableCategories: currentFormValues.formInfo.availableCategories || [],
        selectedCategory: currentFormValues.formInfo.selectedCategory || "",

        availableCouponCode: currentFormValues.formInfo.availableCouponCode || [],
        selectedCouponCode: currentFormValues.formInfo.selectedCouponCode || "",

        selectedCategoryPrice: currentFormValues.formInfo.selectedCategoryPrice || 0,
        numberOfTickets: currentFormValues.formInfo.numberOfTickets || 0,
        pricing: currentFormValues.formInfo.pricing || [],
        sumOfPrice: currentFormValues.formInfo.sumOfPrice || 0,
        isSelectetivePlaces: currentFormValues.formInfo.isSelectetivePlaces || false,
        seatIoId: currentFormValues.formInfo.seatIoId || "",
        buyFromType: currentFormValues.formInfo.buyFromType || "",

        selectedTimeId: currentFormValues?.formInfo?.selectedTimeId,
        isCinema: currentFormValues?.formInfo?.isCinema,
        isCirque: currentFormValues?.formInfo?.isCirque,
      });
      setSelectedPlaces(currentFormValues.seatInfo || []);
    } else {
      setFormDataValues({
        fromEvent: "",
        ticketType: "",
        firstName: "",
        lastName: "",
        email: "",
        phone: "",
        couponCode: "",
        availableCategories: [],
        selectedCategory: "",
        availableCouponCode: [],
        selectedCouponCode: "",
        selectedCategoryPrice: 0,
        numberOfTickets: 0,
        pricing: [],
        sumOfPrice: 0,
        isSelectetivePlaces: false,
        seatIoId: "",
        buyFromType: "",
        selectedTimeId: "",
        isCinema: false,
        isCirque: false,
      });
      setSelectedPlaces([]);
    }
  }, [currentFormValues]);

  return (
    <Card>
      <MDBox p={3}>
        <MDTypography variant="h5">Information</MDTypography>
        <MDBox mt={1}>
          <Grid container spacing={3}>
            {/* Sélecteur d'événement */}
            <Grid item xs={12}>
              <Autocomplete
                options={eventData}
                value={
                  formDataValues.fromEvent
                    ? eventData.find((event) => event.id === formDataValues.fromEvent)
                    : null
                } // Set the value based on the selected event
                isOptionEqualToValue={(option, value) => option.id === value.id}
                getOptionLabel={(option) =>
                  `${option?.title}${option?.isCinema ? " - Cinéma" : option?.isCirque ? " - Cirque" : ""}`
                }
                onChange={handleAutoCompleteEventChange}
                renderInput={(params) => <FormField {...params} label="Événement" />}
              />
            </Grid>
            {/* Type de billet: Ticket ou Invitation */}
            <Grid item xs={12} sm={6} md={4}>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  row
                  name="ticketType"
                  value={formDataValues?.ticketType}
                  onChange={handleRadioChange}
                >
                  <FormControlLabel value="T" control={<Radio />} label="Ticket" />
                  {
                    userRole !== "Revendeur" &&
                    <FormControlLabel value="I" control={<Radio />} label="Invitation" />
                  }
                </RadioGroup>
              </FormControl>
            </Grid>

            {/* Méthode d'achat: Online ou Hors ligne */}
            <Grid item xs={12} sm={6} md={4}>
              <FormControl component="fieldset" fullWidth>
                <FormControlLabel
                  control={
                    <Switch
                      checked={formDataValues?.buyFromType === "online"}
                      onChange={handleBuyFromChange}
                    />
                  }
                  label={formDataValues?.buyFromType === "online" ? "Online" : "Hors ligne"}
                />
              </FormControl>
            </Grid>

            {/* Email */}
            <Grid item xs={12} sm={6} md={4}>
              <FormField
                type="email"
                label="Email"
                name="email"
                value={formDataValues?.email}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Nom */}
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Nom"
                name="firstName"
                value={formDataValues?.firstName}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Prénom */}
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Prénom"
                name="lastName"
                value={formDataValues?.lastName}
                onChange={handleInputChange}
              />
            </Grid>

            {/* Téléphone */}
            <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="N° de téléphone"
                name="phone"
                value={formDataValues?.phone}
                onChange={handleInputChange}
              />
            </Grid>

            {/* <Grid item xs={12} sm={4}>
              <FormField
                type="text"
                label="Code coupon"
                name="couponCode"
                value={formDataValues?.couponCode}
                onChange={handleInputChange}
              />
            </Grid> */}
            <Grid item xs={12} sm={4}>
              <Autocomplete
                // multiple
                // value={selectedEvent}
                isOptionEqualToValue={(option, value) => option._id === value._id}
                options={formDataValues?.availableCouponCode}
                getOptionLabel={(option) => option?.coponCode || ""}
                onChange={handleAutoCompleteCouponChange}
                renderInput={(params) => <FormField {...params} label="Code coupon" />}
              />
            </Grid>
          </Grid>

          <Grid container spacing={3}>
            <Grid item xs={12}>
              <MDTypography variant="h5">Horaires</MDTypography>
              <FormControl component="fieldset" fullWidth>
                <RadioGroup
                  name="selectedTimeId"
                  value={formDataValues?.selectedTimeId}
                  onChange={handleSelectedHourRadioChange}
                >
                  {selectedEventDatesList.map((el) => {
                    return (
                      <FormControlLabel
                        value={el.generatedId}
                        control={<Radio />}
                        label={`${formatedDate(el.eventDate)} - ${formatedTime(el.eventDate)}`}
                      />
                    );
                  })}
                  {/* <FormControlLabel value="T" control={<Radio />} label="Ticket" />
                  <FormControlLabel value="I" control={<Radio />} label="Invitation" /> */}
                </RadioGroup>
              </FormControl>
            </Grid>
          </Grid>

          {!formDataValues?.isSelectetivePlaces && formDataValues?.seatIoId === "" ? (
            <>
              <MDTypography variant="h5" mb={4}>
                Siège {formDataValues.isCinema ? "(Cinéma)" : formDataValues.isCirque ? "(Cirque)" : ""}
              </MDTypography>
              {!(formDataValues.isCinema || formDataValues.isCirque) ? (
                <Grid container spacing={3}>
                  {formDataValues?.availableCategories &&
                  formDataValues?.availableCategories.length !== 0 ? (
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        // multiple
                        // value={selectedEvent}
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        options={formDataValues?.availableCategories}
                        getOptionLabel={(option) => option?.name || ""}
                        onChange={handleAutoCompleteSeigeChange}
                        renderInput={(params) => <FormField {...params} label="Siége" />}
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid item xs={12} sm={4}>
                    <FormField
                      type="number"
                      label="Nombre de tickets"
                      name="numberOfTickets"
                      value={formDataValues?.numberOfTickets}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              ) : (
                <Grid container spacing={3}>
                  {formDataValues?.availableCategories &&
                  formDataValues?.availableCategories.length !== 0 ? (
                    <Grid item xs={12} sm={4}>
                      <Autocomplete
                        isOptionEqualToValue={(option, value) => option.id === value.id}
                        options={formDataValues?.availableCategories}
                        getOptionLabel={(option) => option?.name || ""}
                        onChange={handleAutoCompleteSeigeChange}
                        renderInput={(params) => <FormField {...params} label="Siége" />}
                      />
                    </Grid>
                  ) : (
                    <></>
                  )}
                  <Grid item xs={12} sm={4}>
                    <FormField
                      type="number"
                      label="Nombre de tickets"
                      name="numberOfTickets"
                      value={formDataValues?.numberOfTickets}
                      onChange={handleInputChange}
                    />
                  </Grid>
                </Grid>
              )}
            </>
          ) : (
            <>
              <MDTypography variant="h5" mb={4}>
                Sélectionner via le plan
              </MDTypography>
              <div
                style={{ height: "80vh", width: "100%", marginBottom: "5vh" }}
                id="SeatsioSeatingChart"
              >
                <SeatsioSeatingChart
                  workspaceKey="2b467677-099f-48e3-ac2a-d4032fca5089"
                  event={formDataValues?.seatIoId}
                  pricing={formDataValues?.pricing}
                  priceFormatter={(price) => price + " MAD"}
                  region="eu"
                  onObjectSelected={handleSelectedObject}
                  onObjectDeselected={handleDeselectedObject}
                  selectedObjects={handleSelectedObjects}
                  colorScheme="light"
                  colors={customColors}
                  objectColor={(object, defaultColor) => {
                    if (object.selected) {
                      return "#00FF00";
                    } else {
                      return "#6C096C";
                    }
                  }}
                  showZoomOutButtonOnMobile={false}
                  onChartRendered={handleChartRendered}
                  showMinimap={true}
                  showFullScreenButton={true}
                  objectPopover={objectPopoverParams}
                />
              </div>
            </>
          )}
          <Stack spacing={1} sx={{ alignItems: "center" }}>
            <Stack direction="row" spacing={1}>
              <Chip label="Prix total: " color="success" variant="outlined" />
              <MDTypography variant="p">{parseFloat(formDataValues?.sumOfPrice)} MAD</MDTypography>
            </Stack>
          </Stack>
        </MDBox>
      </MDBox>

      <MDBox mt={4} ml={4}>
        {actionButton}
      </MDBox>
    </Card>
  );
}

FormFields.propTypes = {
  formValues: PropTypes.func.isRequired,
  selectedPlaceEvent: PropTypes.func.isRequired,
  currentFormValues: PropTypes.object.isRequired,
  eventData: PropTypes.array.isRequired,
  actionButton: PropTypes.node.isRequired,
};

export default FormFields;
